var _defs, _rect, _rect2, _rect3, _rect4, _polygon, _polygon2, _path, _line, _path2, _path3, _path4, _path5, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpPostcardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.g,.h{fill:none;}.b,.d{fill:#3c3c46;}.b{opacity:0.15;}.c{fill:#ffefe0;}.c,.e,.f,.g,.h,.i,.j{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.d{opacity:0.2;}.e{fill:#89d9fb;}.e,.f,.g,.i,.j{fill-rule:evenodd;}.f{fill:#fff;}.i{fill:#3ca4ef;}.j{fill:#f2424c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-postcard-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 34.69,
    y: 43.16,
    width: 76.62,
    height: 76.62
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 28.69,
    y: 37.16,
    width: 76.62,
    height: 76.62
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 28.69,
    y: 37.16,
    width: 68.74,
    height: 76.62
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "91.92 20.22 28.69 37.16 28.69 113.78 91.92 96.84 91.92 20.22"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "74.68 85.72 45.93 93.42 60.27 40.99 74.68 85.72"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M72.43,78.73c-8.42,1.4-15.08-1.06-21-5.34,6-2.47,11.64-5.58,15.59-11.51a18.07,18.07,0,0,1-10.92-5.55"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 60.31,
    y1: 89.57,
    x2: 60.4,
    y2: 95.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M70,68.83c1-.27,1.85.51,1.85,1.75A2.88,2.88,0,0,1,70,73.31c-1,.27-1.85-.51-1.85-1.75A2.88,2.88,0,0,1,70,68.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M53.95,62.7c1-.27,1.85.51,1.85,1.75a2.88,2.88,0,0,1-1.85,2.74c-1,.27-1.85-.51-1.85-1.75A2.88,2.88,0,0,1,53.95,62.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M55.8,79.77c1-.27,1.85.51,1.85,1.75a2.88,2.88,0,0,1-1.85,2.74c-1,.27-1.85-.51-1.85-1.75A2.88,2.88,0,0,1,55.8,79.77Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M63.74,49.49c1-.27,1.85.51,1.85,1.75A2.88,2.88,0,0,1,63.74,54c-1,.27-1.85-.51-1.85-1.75A2.88,2.88,0,0,1,63.74,49.49Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 77.99,
    y1: 31.74,
    x2: 77.99,
    y2: 46.74
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 82.37,
    y1: 32.76,
    x2: 73.61,
    y2: 45.72
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 84.18,
    y1: 37.58,
    x2: 71.8,
    y2: 40.9
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 82.37,
    y1: 43.37,
    x2: 73.61,
    y2: 35.11
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 41.79,
    y1: 57.42,
    x2: 41.79,
    y2: 70.1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 45.49,
    y1: 58.29,
    x2: 38.1,
    y2: 69.23
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 47.02,
    y1: 62.36,
    x2: 36.57,
    y2: 65.16
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 45.49,
    y1: 67.25,
    x2: 38.1,
    y2: 60.27
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 82.62,
    y1: 69.82,
    x2: 82.62,
    y2: 79.56
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 85.46,
    y1: 70.49,
    x2: 79.77,
    y2: 78.89
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 86.63,
    y1: 73.61,
    x2: 78.6,
    y2: 75.77
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 85.46,
    y1: 77.37,
    x2: 79.77,
    y2: 72.01
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpPostcardIcon);
export default __webpack_public_path__ + "static/media/CP-postcard-icon.7a8787c80e36c6d7c6217fd8bb569c29.svg";
export { ForwardRef as ReactComponent };